import React, { useEffect } from "react";

import DropdownMenu, {
    CustomTriggerProps,
    DropdownItemGroup
} from "@atlaskit/dropdown-menu";

import {
    CustomerDomainDetails,
    CustomerDomainOrg
} from "../../../../state/types";

import { OTHER_ORG_FILTER, DEFAULT_ORG_FILTERS_ORDER } from "./constants";
import { OrgSelectorDropdownButton } from "./org-selector-dropdown-button";
import { OrgSelectorDropdownItem } from "./org-selector-dropdown-item";

export const OrgSelectorDropdown: React.FC<{
    customerDomain: CustomerDomainDetails;
    selectedDomainOrg: CustomerDomainOrg | null;
    onSetSelectedDomainOrg: (org: CustomerDomainOrg) => void;
}> = ({ customerDomain, selectedDomainOrg, onSetSelectedDomainOrg }) => {
    const { data: customerDomainData, pending: customerDomainPending } =
        customerDomain;

    const hasOrgs =
        (!customerDomainPending &&
            customerDomainData &&
            customerDomainData.orgsWithAdminRole.length > 0) ||
        false;

    useEffect(() => {
        if (!customerDomainPending && customerDomainData) {
            if (hasOrgs && !selectedDomainOrg) {
                const firstOrg = customerDomainData.orgsWithAdminRole[0];

                if (firstOrg) {
                    onSetSelectedDomainOrg(firstOrg);
                }
            }

            if (!hasOrgs && !selectedDomainOrg) {
                onSetSelectedDomainOrg(OTHER_ORG_FILTER);
            }
        }
    }, [
        customerDomainData,
        customerDomainPending,
        hasOrgs,
        selectedDomainOrg,
        onSetSelectedDomainOrg
    ]);

    return (
        <DropdownMenu
            // This is atlaskit's recommended pattern for custom trigger components
            // eslint-disable-next-line react/no-unstable-nested-components
            trigger={({ triggerRef, ...providedProps }: CustomTriggerProps) => (
                <OrgSelectorDropdownButton
                    triggerRef={triggerRef}
                    {...providedProps}
                    selectedDomainOrg={selectedDomainOrg}
                    isLoading={customerDomainPending}
                    isDisabled={customerDomainPending}
                />
            )}
            spacing="compact"
            shouldRenderToParent
            isLoading={customerDomainPending}
        >
            <DropdownItemGroup>
                {customerDomainData &&
                    [
                        ...customerDomainData.orgsWithAdminRole,
                        ...DEFAULT_ORG_FILTERS_ORDER
                    ].map((org) => (
                        <OrgSelectorDropdownItem
                            key={org.orgId}
                            org={org}
                            isSelected={org.orgId === selectedDomainOrg?.orgId}
                            onSetSelectedDomainOrg={onSetSelectedDomainOrg}
                        />
                    ))}
            </DropdownItemGroup>
        </DropdownMenu>
    );
};
